import { getPostCover } from '@wix/communities-forum-client-commons';

export const shouldRenderCover = (post = {}) => getPostCover(post).shouldRender;
